var map = {
	"./icon-social-email": [
		74878,
		4878
	],
	"./icon-social-email/": [
		74878,
		4878
	],
	"./icon-social-email/index": [
		74878,
		4878
	],
	"./icon-social-email/index.js": [
		74878,
		4878
	],
	"./icon-social-facebook": [
		65901,
		5901
	],
	"./icon-social-facebook/": [
		65901,
		5901
	],
	"./icon-social-facebook/index": [
		65901,
		5901
	],
	"./icon-social-facebook/index.js": [
		65901,
		5901
	],
	"./icon-social-instagram": [
		93816,
		3816
	],
	"./icon-social-instagram/": [
		93816,
		3816
	],
	"./icon-social-instagram/index": [
		93816,
		3816
	],
	"./icon-social-instagram/index.js": [
		93816,
		3816
	],
	"./icon-social-pinterest": [
		22512,
		2512
	],
	"./icon-social-pinterest/": [
		22512,
		2512
	],
	"./icon-social-pinterest/index": [
		22512,
		2512
	],
	"./icon-social-pinterest/index.js": [
		22512,
		2512
	],
	"./icon-social-twitter": [
		40807,
		807
	],
	"./icon-social-twitter/": [
		40807,
		807
	],
	"./icon-social-twitter/index": [
		40807,
		807
	],
	"./icon-social-twitter/index.js": [
		40807,
		807
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 10006;
module.exports = webpackAsyncContext;